/**
 * Typed access to client build-time configuration. Vite exposes variables
 * prefixed with `VITE_` on `import.meta.env`. Centralising access here keeps
 * `import.meta.env` out of the rest of the codebase and gives one place to add
 * validation as configuration grows.
 */
export const env = {
  /** API base path. Empty string means "same origin" (the default, since the
   *  server serves the client and the dev server proxies /api). */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
